import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useMedia } from '@mlb/react-patterns/v4/utils/hooks/useMedia/useMedia';
import { AtBatWrapper, DetailTitleWrapper, ModalTypes } from './atbat.style';
import MobileAtBatPlay from './components/MobileAtBatPlay';
import DesktopAtBatPlay from './components/DesktopAtBatPlay';
import AtBatShareDataContainer from './containers/AtBatShareDataContainer';
import { getAtBatState } from './store/selectors/getAtBat';
import Overlay from '@gameday/components/Overlay/Overlay';
import Explore from '@gameday/components/FieldVision/components/auth/Explore';
import { FieldVisionModalContent } from '../Overlay/overlay.style';
import { TYPES } from '@gameday/components/FieldVision/components/auth/index';
import { ATBAT_MODAL_BREAKPOINT } from '@gameday/components/themes/breakpoints';
import NoOktaOrFV from '../Live/components//NoOktaOrFV';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';

const setComponentType = () => {};
const AtBatPlay = ({
    playIndex
}) => {
    const [isAuthOpen, setAuthOpen] = useState(false);
    const onAuthClose = useCallback(() => {
        setAuthOpen(false);
    }, [setAuthOpen]);
    const onAuthOpen = useCallback(() => {
        setAuthOpen(true);
    }, [setAuthOpen]);
    const [isTutorialOpen, setTutorialOpen] = useState(false);
    const onTutorialClose = () => setTutorialOpen(false);
    const translate = useTranslate();
    const detailLabel = translate('label_play_detail', 'Play Detail');

    const {
        lockView
    } = useSelector(getAtBatState(playIndex));

    let isSingleCol = useMedia({ maxWidth: ATBAT_MODAL_BREAKPOINT });
    const [cachedView, setCachedView] = useState(null);

    if (lockView) {
        isSingleCol = cachedView?.isSingleCol;
    }

    useEffect(() => {
        setCachedView({
            isSingleCol
        });
    }, [lockView, isSingleCol]);

    return (
        <AtBatWrapper>
            {isSingleCol
                ? <DetailTitleWrapper>
                    <span>{detailLabel}</span>
                    <AtBatShareDataContainer isMobile={isSingleCol} playIndex={playIndex} />
                </DetailTitleWrapper>
                : <AtBatShareDataContainer isMobile={isSingleCol} playIndex={playIndex} />
            }

            {!isSingleCol ? <DesktopAtBatPlay playIndex={playIndex} onAuthOpen={onAuthOpen} setTutorialOpen={setTutorialOpen} /> : <MobileAtBatPlay playIndex={playIndex} onAuthOpen={onAuthOpen} setTutorialOpen={setTutorialOpen} /> }
            <NoOktaOrFV
                isSingleCol={isSingleCol}
                isAuthOpen={isAuthOpen}
                componentType={TYPES.LOGIN}
                onClose={onAuthClose}
                setComponentType={setComponentType}
                lockView={true}
            />
            <Overlay
                isCentered={true}
                isOpen={isTutorialOpen}
                onClose={onTutorialClose}
                type={!isSingleCol ? ModalTypes.FIELDVISION : ModalTypes.FIELDVISION_VERTICAL}
                ContentComponent={!isSingleCol ? FieldVisionModalContent : null}
            >
                <Explore isSingleCol={isSingleCol}/>
            </Overlay>
        </AtBatWrapper>
    );
};

AtBatPlay.propTypes = {
    playIndex: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number])
};

export default AtBatPlay;
